import React from 'react'
import classnames from 'classnames'
import { Dropdown, Input } from 'antd'
import classes from './index.module.scss'

const { style, dropdownStyle } = classes

// `unitOptions`/`onUnitChange` are optional — when omitted, the suffix is
// plain text exactly as before (e.g. CompleteProfile.js's usage). When
// provided (About You's unit-switchable height/weight), the suffix itself
// becomes the click target for a small popover to switch units — mirrors
// fiton-web's NumberSelectV2 unit switcher (click the unit, pick from a
// dropdown), rather than a separate button placed beside the input.
const HeightInputNumber = ({
  value,
  setValue,
  placeholder,
  unit,
  max,
  min,
  className,
  inputRef,
  unitOptions,
  // The current unit's *value* (e.g. 'inch'/'cm'), distinct from `unit`
  // (the display suffix, e.g. 'ft'/'in'/'cm') — height's ft and in fields
  // share one currentUnit ('inch') despite showing different suffix text,
  // so this can't be derived from `unit` alone.
  currentUnit,
  onUnitChange,
}) => {
  const onChange = (e) => {
    const regex = /^\d*$/
    const value = e.target.value
    if (regex.test(value)) {
      setValue(value)
    }
  }

  const onBlur = (e) => {
    const value = e.target.value
    if (value.length > 0) {
      const numberValue = Number(value)
      if (numberValue < min) {
        setValue(min)
      } else if (numberValue > max) {
        setValue(max)
      } else {
        setValue(value)
      }
    } else if (value.length === 0) {
      setValue('')
    }
  }

  const suffix =
    unitOptions && onUnitChange ? (
      <Dropdown
        trigger={['click']}
        placement='bottom'
        overlayClassName={dropdownStyle}
        menu={{
          items: unitOptions.map((option) => ({
            key: option.value,
            label: option.label,
          })),
          selectedKeys: currentUnit ? [currentUnit] : [],
          onClick: ({ key }) => onUnitChange(key),
        }}
      >
        <span className='unit-suffix-trigger'>{unit}</span>
      </Dropdown>
    ) : (
      unit
    )

  return (
    <div className={classnames(style, className)}>
      <Input
        ref={inputRef}
        rootClassName='input-sec'
        value={value}
        suffix={suffix}
        onChange={onChange}
        placeholder={placeholder}
        controls={false}
        maxLength={max.toString().length}
        onBlur={onBlur}
        type='text'
        pattern='\d*'
        inputMode='numeric'
      />
    </div>
  )
}

export default HeightInputNumber
